// @need-translate
import {TextTKey} from '../../../../../../common/type';
import {TalkViewerErrorType} from '../../../../../../errors/TalkViewerErrorType.enum';
import {TalkEffectType} from '../type/TalkEffectType.enum';
import {TalkViewerFontFamilyType} from '../type/TalkViewerFontFamilyType.enum';

// 디자인 가이드 기준 px
export const BASE_VIEWER_WIDTH_PX = 720;
// 뷰어 요소에 최대로 적용 할 기준 px (이 이상으로 요소크기가 커지지 않습니다.)
export const MAX_BASE_VIEWER_WIDTH_PX = 420;

export const PREVENT_SCROLL_CLASSNAME = 'preventScroll';

export const TALK_VIEWER_STATE_NAME = 'talkViewer';

export const DEFAULT_TOP_VIEWER_MENU_HEIGHT_PX = 56;
export const DEFAULT_BOTTOM_VIEWER_MENU_HEIGHT_PX = 81;

export const FONT_FAMILY_FILE_NAME: {
  [key in TalkViewerFontFamilyType]: string;
} = {
  [TalkViewerFontFamilyType.Gothic]: 'NotoSans-Regular.otf',
  [TalkViewerFontFamilyType.Myeongjo]: 'NotoSerif-Regular.otf',
  [TalkViewerFontFamilyType.Default]: 'NotoSans-Regular.otf',
};

export const LOCAL_STORAGE_KEY_TUTORIAL_EXPOSED = 'kn_tutorial_exposed_already';

export const LOCAL_STORAGE_KEY_DATA_USING_AGREE = 'data_using_agree';

export const ANIMATION_DURATION: {
  [key in TalkEffectType]: number;
} = {
  [TalkEffectType.Shake]: 0.5,
  [TalkEffectType.FadeIn]: 1.5,
  [TalkEffectType.Rise]: 2,
  [TalkEffectType.Flick]: 0.5,
  [TalkEffectType.None]: 0,
  // 타이핑은 css애니메이션이 아닌 별도의 자바스크립트 구현으로 만들어졌기 때문에 0초로 둔다
  [TalkEffectType.Typing]: 0,
};

// 타이핑 글효과에서는 특정 시간 간격으로 글자를 1개씩 노출시켜 준다. 기획과 실제 구현 내용을 보면서 속도를 정했다.
export const TYPEWRITE_EFFECT_SPEED = 80;

export const VIEWER_END_PAGE_COUNT = 1;

export const KATALK_HEADER_HEIGHT = 96;

export const DISPLAY_AD_HEIGHT = 98;

export const MOBILE_PULL_COMPONENT_HEIGHT = 62;
export const PC_PULL_COMPONENT_HEIGHT = 150;

export const COMMON_BOX_STYLE =
  'w-660tvs max-w-660tvs rounded-8tvs pt-24.5tvs pb-26.5tvs px-28tvs';

export const TALK_VIEWER_MIN_INTERFACE_VERSION = 3;

export const CLOSE_TALK_VIEWER_ERROR_TYPE_LIST = [
  TalkViewerErrorType.DecryptFail,
  TalkViewerErrorType.NoContentUrl,
  TalkViewerErrorType.NoDecryptKey,
  TalkViewerErrorType.NeedAppLogin,
];

export const REFRESH_TALK_VIEWER_ERROR_TYPE_LIST = [
  TalkViewerErrorType.AppError,
  TalkViewerErrorType.UnknownError,
];

export const TALK_VIEWER_ERROR_MESSAGE_MAP: {
  [key in TalkViewerErrorType]: TextTKey;
} = {
  [TalkViewerErrorType.AppError]: {
    text: '뷰어를 불러오지 못했습니다.\n다시 시도해주세요.',
    // @ts-expect-error
    textTKey: '',
  },
  [TalkViewerErrorType.DecryptFail]: {
    text: '뷰어를 불러오지 못했습니다.',
    // @ts-expect-error
    textTKey: '',
  },
  [TalkViewerErrorType.NeedUpdate]: {
    text: '업데이트가 필요합니다.',
    // @ts-expect-error
    textTKey: '',
  },
  [TalkViewerErrorType.NoContentUrl]: {
    text: '잘못된 경로입니다.',
    textTKey: 'viewer_error_invalid_url',
  },
  [TalkViewerErrorType.UnknownError]: {
    text: '뷰어를 불러오지 못했습니다.\n다시 시도해주세요.',
    // @ts-expect-error
    textTKey: '',
  },
  [TalkViewerErrorType.NeedAppLogin]: {
    text: '로그인 세션이 만료되었습니다',
    // @ts-expect-error
    textTKey: '',
  },
};

export const IGNORE_GLOBAL_FONT_SET_CLASSNAME = 'ignore-global-font-family';

export const LOCAL_STORAGE_KEY_AUTO_TAP_TOOLTIP_HIDDEN =
  'auto_tap_tooltip_hidden';
